import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MoreHorizontal } from 'lucide-react';
import { useInteraction } from '../InteractionContext.js';
import { getIcon } from '../icons.js';
import { getVariant, hasFlag } from '../layout.js';
import { cn } from '../lib/utils.js';
import { Button } from '../ui/button.js';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger, } from '../ui/dropdown-menu.js';
export function Dropdown({ element }) {
    const { handleAction } = useInteraction();
    const { props, content, children } = element;
    const isDisabled = hasFlag(props, 'disabled');
    const isOpen = hasFlag(props, 'open');
    // Get trigger content
    const triggerContent = typeof content === 'string' ? content : undefined;
    // Render a menu item from a child element
    const renderMenuItem = (child, index) => {
        if (child.type !== 'element')
            return null;
        const childElement = child;
        // Handle divider
        if (childElement.elementType === 'divider') {
            return _jsx(DropdownMenuSeparator, {}, index);
        }
        // Handle button or other elements as menu items
        const itemContent = typeof childElement.content === 'string' ? childElement.content : '';
        const itemProps = childElement.props;
        const variant = getVariant(itemProps);
        const isDanger = variant === 'danger' || hasFlag(itemProps, 'danger');
        const isItemDisabled = hasFlag(itemProps, 'disabled');
        const toValue = itemProps.to;
        // Get icon if specified
        const iconName = typeof itemProps.icon === 'string' ? itemProps.icon : undefined;
        const IconComponent = iconName ? getIcon(iconName) : undefined;
        const handleClick = () => {
            if (isItemDisabled)
                return;
            if (!toValue)
                return;
            if (typeof toValue === 'object' && 'type' in toValue) {
                switch (toValue.type) {
                    case 'screen':
                        handleAction(toValue.id);
                        break;
                    case 'overlay':
                        handleAction(`#${toValue.id}`);
                        break;
                    case 'action':
                        handleAction(`:${toValue.action}`);
                        break;
                    case 'url':
                        window.open(toValue.url, '_blank');
                        break;
                }
            }
            else if (typeof toValue === 'string') {
                handleAction(toValue);
            }
        };
        return (_jsxs(DropdownMenuItem, { disabled: isItemDisabled, onClick: handleClick, className: cn(isDanger && 'text-destructive focus:text-destructive'), children: [IconComponent && _jsx(IconComponent, { size: 16, className: "mr-2" }), itemContent] }, index));
    };
    return (_jsxs(DropdownMenu, { defaultOpen: isOpen, children: [_jsx(DropdownMenuTrigger, { asChild: true, disabled: isDisabled, children: _jsx(Button, { variant: "ghost", size: triggerContent ? 'default' : 'icon', disabled: isDisabled, children: triggerContent || _jsx(MoreHorizontal, { size: 16 }) }) }), _jsx(DropdownMenuContent, { align: "end", children: children.map((child, index) => renderMenuItem(child, index)) })] }));
}
//# sourceMappingURL=Dropdown.js.map